import styled from '@emotion/styled';

export default styled.div({
    padding: '1rem 0 1rem 0'
});
